import { Trade } from "./Trade";
import { PhaseTag } from "./PhaseTag";
import { PhaseLocation } from "./Location";
import { TagType } from "./ TagType";
import { PullInfo } from "../modules/lookahead.reducer";

export enum  PhasePlanStatus {
    Planning='Planning',
    Started='Started'
}

export class PhasePlan {
    locations?: Record<string, PhaseLocation>;
    trades?: Record<string, Trade>;
    tags?: Record<string, PhaseTag>;
    name?: string;
    constraints?: object;
    status?: PhasePlanStatus = PhasePlanStatus.Planning;
    pullInfo?: PullInfo
}





// WEBPACK FOOTER //
// ./src/models/PhasePlan.ts